/**
 * Changelog - todas as mudanças sem limite.
 * Formato: [modulo] [função] - {breve descrição}
 * Seções vazias: -----
 *
 * ⚠️ ANTES DE EDITAR: rodar no terminal: Get-Date -Format "dd/MM/yyyy"
 *    Usar a data retornada. Nunca confiar em data de contexto.
 */
export default [
	{
		date: '10/04/2026',
		changes: [
			'[PORTAIS AWS / portal-cliente] `sialbi_base_url()` — base correta para scripts em `core/auth/` e módulos em `public/` (links de e-mail e redirects); `config.php` carrega `vendor/autoload.php` quando existir',
			'[PORTAIS AWS / portal-cliente] Recuperação de senha — `global $pdo` nos processos de auth; checagem de PHPMailer com mensagem se faltar `composer install`',
			'[PORTAIS AWS / portal-cliente] Kardex API — resposta JSON 403 com `error`, `hint` e referência às migrações 051/053 (permissões `login_sial`)',
			'[DEPLOY / portais AWS] `deploy-portais-aws.ps1` — passo 3b `composer install` no servidor; passo 4 `sed` com delimitador `#` e dois `ssh` (evita ParseException no PowerShell e pipe `|` quebrando o bash remoto)',
		],
		add: [],
		bugfix: [],
	},
	{
		date: '09/04/2026',
		changes: [
			'[EMBALAGENS / IMPRESSÕES] Relatório CSV cadastro completo — menu Imprimir em Catálogo > Embalagens; modal (empresa, produto opcional, nível P/S/T, situação ativas/inativas/todas, máx. linhas); API `GET /companies/<id>/reports/product-packagings`; migração `072-report-product-packagings-endpoint.sql`',
			'[INTEGRAÇÃO / #MT-4A62870] Documento para cliente AMIL — API somente leitura de estoque (`GET /stocks`), auth por cookie, exemplos curl e PowerShell: `doc/integrations/AMIL-MT-4A62870-api-consulta-estoque.md`',
			'[NF-E / FIEL DEPOSITÁRIO] Grupo `transporta` — preenchimento de `UF`, `xMun` e `xEnder` a partir do endereço do emitente (armazenador); evita rejeição SEFAZ 559 «UF do Transportador não informada»',
			'[NF-E] Trava por pedido — não permite nova NF para o mesmo pedido (entrada/saída) se já existir nota ativa sem cancelamento (`PT_CAN`) nem inutilização (`PT_INUT`); notas `is_disabled` ignoradas; ativo imobilizado (`io_type A`) fora da regra; `list_invoice_ids_for_pedido` + validação em insert/update/patch de invoices',
			'[EMPRESAS / UI] Telefone do responsável técnico (`infRespTec`) — tipo `phone_inf_resp_tec`: aceita DDI 55 ou número nacional com zero opcional antes do DDD (ex.: `01930148080`); antes `types.phone()` exigia só `55` e bloqueava salvar',
			'[LOTES] Grade «Lotes» — coluna «Endereço» (texto completo da posição, ex.: `1-a-1-1`; várias posições com ` | `) a partir de estoques com saldo; campo calculado `location_address` no list; `default_columns` inclui coluna 12',
			'[NF-E / EVENTOS] Cancelamento — `remove_empty_tags` não roda mais sobre o `detEvento` após anexá-lo (evitava `<nProt>` vazio e gerava XSD «nProt esperado / xJust na posição errada»); validação de lote: justificativa ≥15 caracteres antes de gravar; exige protocolo PT_AUT (prioriza código 100) antes de montar o XML; placeholder no modal «Gerar lotes»',
			'[PEDIDOS SAÍDA / #MT-DF5A250] Gerar saídas — modal «Resultados»: fundo vermelho linha 0% atendido, amarelo atendimento parcial (<100%); `create_outputs` inclui no relatório todas as linhas pendentes (incl. 0 atendido e bloqueio embalagem)',
			'[SAÍDAS] Aviso de Remessa (PDF) — colunas «Vl. unit.» e «Vl. item» (total da linha com desconto % alinhado à NF-e); resumo «Valor Total (R$)» = soma dos itens exibidos',
			'[ESTOQUES / GRADE] Configurar colunas — grade alinhada aos índices SQL e ao `fieldspecs` (antes Emb./Fator/QR e Programa estavam trocados em relação aos checkboxes); coluna «Cód. cliente» (18) exibida; migração `stocks_grid_v3` reseta `stocks.setup.columns` uma vez no navegador',
			'[SAÍDAS / ETIQUETA] Layout SESSP (ZPL) — modelo IBL: cabeçalho com razão social da empresa; Código/Produto/Quant lote/Volumes; Data pedido, Pedido, Lote, Validade; destinatário em bloco; área DRS (valor reservado para agrupamento futuro de locais); QR mantém `nNF|volume|total`; dados de produto/lote do primeiro item da saída (`output_items`)',
		],
		add: [],
		bugfix: [],
	},
	{
		date: '08/04/2026',
		changes: [
			'[EMPRESAS] Aba «Parâmetros» no cadastro de empresa — checkboxes de inventário/embalagens concentrados nela; opção «Atendimento na geração de saídas» (parcial padrão vs total 100% do pendente); `create_outputs` bloqueia saída parcial quando «total» e reverte itens simulados no lote; coluna `companies.output_orders_require_full_fulfillment`; migração `068-companies-output-orders-full-fulfillment.sql`',
			'[AUTH / PROGRAMAS] Endpoint `GET /companies/<company_id>/programs` cadastrado e com permissões (antes só existiam `GET /programs` e `GET .../programs/<id>` — a listagem por empresa caía em 403); migração `069-seed-get-company-programs-list-endpoint.sql`; `008-seed-programs-endpoints.sql` alinhado para novos installs',
			'[SAÍDAS] Resultado de «Gerar saídas» com pedido não aprovado — API passa `reservation_note` e itens com `stock_evaluated: false`; modal Resultados destaca o aviso (evita confundir com falta de estoque)',
		],
		add: [
			'[MIGRAÇÃO] 068 — `output_orders_require_full_fulfillment` em companies',
			'[MIGRAÇÃO] 069 — endpoint GET lista programas por empresa + permissões',
		],
		bugfix: [],
	},
	{
		date: '07/04/2026',
		changes: [
			'[BI] Analítico Estoque — menu BI > Analítico Estoque; modal (empresa, programa, armazém, produto com lista SKU/nome + busca servidor, lote); prévia em tabela ou CSV; API `GET /companies/<id>/reports/stock-complete` (base `doc/queries/relatorio-estoque-completo.sql`); migração `067-bi-stock-complete-report-endpoint.sql` + seed',
			'[MIGRAÇÃO] 031 — antes de `product_packagings_uq_product_code`, deduplica embalagens ativas com mesmo (empresa, produto, código): menor `id` permanece; `lots` / `input_items` apontam para ele se as colunas existirem; demais linhas `is_disabled=true` (corrige `UniqueViolation` em deploy)',
			'[ENTRADAS / Relatório] Conferência de entrada (PDF) — `SQL_ITEMS` e `SQL_LOTS_ONLY` ignoram lotes com bit `ST_DISABLED` (exclusão lógica do lote). Antes o JOIN trazia esses lotes e o PDF listava linhas a mais / conferências “apagadas”',
			'[BI / Kardex] Lista de produtos — a API corta `limit` em 500; a tela pedia 5000 e só recebia os primeiros 500 por SKU, omitindo muitos itens (ex.: SKU existente em estoque mas fora do lote). Agora pagina com `offset` até esgotar e usa `include_disabled=1`; rótulo «[inativo]» quando aplicável',
			'[ESTOQUES] Operação «Bloquear estoque» — uma linha na grade; modal com quantidade, motivo e Natureza (MOV / RESUP / INV / BLOQ / UNPICK, padrão BLOQ); L→B na mesma posição via `POST .../lots/{id}/move`; backend `Lots.move` repassa `movement_kind` opcional para `transactions.register`',
			'[ESTOQUES] Bloquear estoque — correção: `getSelection()` devolve tupla `[company_id, stock_id]` (data-id da grade), não objeto; evita `GET .../companies/undefined/stocks/undefined` e 405',
			'[MOVIMENTAÇÃO] Mover posição inteira — POST `/companies/.../warehouses/.../locations/.../move-all-available` (`bulk_move_location_available`): todo `quantity_available` L→L por linha; bloqueio se houver reserva ou bloqueio na posição; motivo/natureza opcional; UI Movimentações > «Mover posição inteira»; migração `062-seed-location-move-all-available-endpoint.sql`; doc ColetorPWA §7.3 (#MT-8EC3321)',
			'[BI] Kardex (analítico) — exibição operacional: Origem/Destino com texto referenciado (armazém, endereço, NF, pedido, ressup, inventário) via `formatTransactionEndpointDisplay` + prefetch IndexedDB (warehouses, locations, lots, inputs, outputs); coluna tipo com rótulos legíveis; lote com numeração amigável (sem `lot_id` cru); primeira coluna `Seq.` (ordem no relatório) em vez de id de transação visível — id interno só em tooltip',
			'[MOVIMENTAÇÕES] `format-transaction-endpoint.js` — rótulos para vínculos NF/pedido em I/O e em R/L; `extrasSuffix` sem «Entrada #id» genérico; sync/async alinhados à mesma lógica de texto curto',
		],
		add: [
			'[MIGRAÇÃO] 067 — BI Analítico Estoque (`GET .../reports/stock-complete`) + permissões',
			'[MIGRAÇÃO] 062 — endpoint POST mover posição inteira + permissões (Administradores, grupos com GET `/locations` ou GET `/stocks`)',
		],
		bugfix: [],
	},
	{
		date: '06/04/2026',
		changes: [
			'[ENTRADAS] Modal de entrada — colunas Embalagem (lista por produto) e Fabricante (somente leitura, da embalagem); `product_packaging_id` em `input_items`; grade de entradas com resumo embalagem/fabricante; relatórios: listagem PDF, detalhada, custos, conferência, endereçamento; `crud.run` aceita `default_columns`; migração `058-input-items-product-packaging.sql`',
			'[ENTRADAS / RELATÓRIOS] Empenho e tipo de recebimento (pedido de entrada) no PDF de conferência de entrada, listagem de entradas e entrada detalhada — alinhado ao documento de pedido de entrada (#MT-866E541)',
			'[NF-E / FIEL DEPOSITÁRIO] Entrada cobertura (CFOP 1905/2905): itens passam a marcar `custody_deposit_entry` — IPI IPINT CST 03, PIS/COFINS Outr CST 70 com base zero (como XML SESSP modelo), em vez de IPI 53 + PIS/COFINS NT 08',
			'[NF-E / EMPRESAS] Responsável técnico (`infRespTec`) — cadastro na aba Textos padrões (CNPJ, contato, e-mail, fone); injetado só na NF-e de entrada quando os quatro campos estão preenchidos; prioridade sobre `config.ini` [nfe]; migração `057-companies-nfe-inf-resp-tec.sql`',
		],
		add: [
			'[MIGRAÇÃO] 057 — `companies.nfe_inf_resp_tec_*` (responsável técnico NF-e)',
			'[MIGRAÇÃO] 058 — `input_items.product_packaging_id` (embalagem na linha da entrada)',
		],
		bugfix: [
			'[PRODUTOS] cBenef SP — input existia no HTML mas não estava em `fields` do form; `getValues()` não enviava o valor e o save gravava `null`',
		],
	},
	{
		date: '04/04/2026',
		changes: [
			'[NF-E / PRODUTOS] cBenef (SP) — campo `c_benef` no produto, tag `<cBenef>` no XML, validação antes da montagem do XML (emitente SP + medicamento + CST ICMS 30/40/41, vigência a partir de 06/04/2026); formulário Medicamentos; migração `054-products-cbenef-sp.sql` (#MT-C716823)',
			'[MIGRAÇÕES] `run-all.py` — inclusão da migração 054 (evita coluna `products.c_benef` ausente se só rodar run-all)',
			'[NF-E / EMPRESAS] Textos padrão `infCpl` por empresa — aba «Textos padrões» no cadastro de empresa (`nfe_inf_cpl_entrada` / `nfe_inf_cpl_saida`); placeholders expandidos em `invoices_xml` ([CLIENTE], [CNPJ CLIENTE], [LOCAL DE ENTREGA], [CNPJ FIEL DEPOSITARIO], [CNPJ EMPRESA (TENNANT)], etc.); removidos do formulário cliente/fornecedor; migração `056-companies-nfe-inf-cpl-templates.sql` (#MT-AAAD428)',
			'[EMPRESAS / UI] Aba Textos padrões — `textarea` NF entrada com a mesma largura da NF saída (`label` em bloco + classe `company-nfe-textarea-label`)',
			'[SAÍDAS / API] `cancel_outputs` — estorna transações R→O ativas quando `status < 90` antes de R→L; transação DB por saída; erros por id sem abortar o lote; runbook `doc/MT-34EB896-operacao-ajuste-autorizado.md` (#MT-34EB896)',
		],
		add: [
			'[MIGRAÇÃO] 054 — `products.c_benef` (código benefício fiscal NF-e SP)',
			'[MIGRAÇÃO] 055 — `customers`/`suppliers` textos infCpl (legado; não usados mais na UI — fonte única na empresa)',
			'[MIGRAÇÃO] 056 — `companies.nfe_inf_cpl_entrada` / `nfe_inf_cpl_saida`',
		],
		bugfix: [
			'[SAÍDAS] Cancelamento com baixa (R→O) já gravada e status ainda faturado — evita «reserva negativa» ao estornar R→O órfã (#MT-34EB896)',
		],
	},
	{
		date: '03/04/2026',
		changes: [
			'[BI] Kardex — lista de produtos por empresa (filtro API), seleção por SKU/nome e busca local na lista',
		],
		add: [],
		bugfix: [
			'[BI] Kardex — filtro de produtos: `encodeURIComponent(fe)` (correção ReferenceError ao trocar empresa)',
		],
	},
	{
		date: '02/04/2026',
		changes: [
			'[BI] Menu BI > Kardex; GET `/companies/<id>/reports/kardex` (analítico paginado) e `.../kardex/summary`; `cost_mode=none|transaction`; migração 051 (índice + endpoints + permissões); front `js/views/bi-kardex.js` (#MT-1DB4950)',
			'[EMPRESAS] Fiel depositário — campos opcionais NF-e XML: `custody_emit_fantasia`, `custody_nfe_inf_cpl`, `custody_transport_cnpj`, `custody_transport_ie` (entity/repo/service + migração `doc/migrations/052-companies-custody-nfe-xml-fields.sql`)',
			'[NF-E] Saída em fiel depositário (CFOP 5905–5907 / 6905–6907): XML alinhado ao modelo legado (dest depositante, refNF, sem IPI/IBS-CBS nos itens, transp mod. 1, infAdic, etc.) em `invoices_xml` / `invoice_xml`',
		],
		add: [
			'[MIGRAÇÃO] 051 — BI Kardex (índice + endpoints GET `/reports/kardex`)',
			'[MIGRAÇÃO] 052 — colunas empresa custody NF-e XML (`doc/migrations/052-companies-custody-nfe-xml-fields.sql`; espelho em `doc/migration-companies-custody-nfe-xml.sql`)',
		],
		bugfix: [],
	},
	{
		date: '01/04/2026',
		changes: [
			'[ENTRADAS] Relatório completo (status, NF do pedido, IDs/chaves/ref. NF-e WMS, CFOP, SEFAZ, empenho/tipo recebimento): POST `/inputs/print-complete` + `/inputs/print-complete/count`; PDF/CSV/XLSX; menu Impressões + modal de filtros (#MT-ABC7404); migração `060-inputs-complete-report-endpoints.sql`',
			'[PEDIDOS ENTRADA] Campo NF (`nf_number`): formulário, grade, filtro e documento PDF; índice e migração `doc/migration-input-orders-nf-number.sql` (#MT-51E7816)',
			'[PEDIDOS ENTRADA] API GET `.../pending` retorna `{ items, nf_number }` para preencher a Nota na tela de Entrada quando vazia',
			'[ENTRADAS] Ao vincular pedido de entrada (tipo I), `invoice_number` copiado do `nf_number` do pedido se a nota estiver em branco (API + `_check_input`)',
			'[INTEGRAÇÕES] TechHub-IBL — criação de pedido de entrada lê `nf_number` / `numero_nf` / `nr_nf` / `nf` do payload',
		],
		add: [
			'[MIGRAÇÃO] `input_orders.nf_number` — ver `doc/migration-input-orders-nf-number.sql`',
			'[MIGRAÇÃO] 060 — endpoints relatório completo de entradas (`060-inputs-complete-report-endpoints.sql`)',
		],
		bugfix: [
			'[PEDIDOS/API] `find_CFOP` sem uso de `cfop_norm` indefinido em `_nfe_recipient_from_order`',
		],
	},
	{
		date: '31/03/2026',
		changes: [
			'[ENTRADAS] Persistência de formulário no submit: syncFromDom em versa/form.js e versa/formset.js para não perder valores em foco',
			'[ENTRADAS] Checkboxes: leitura por checked no versa/field.js, corrigindo marcação automática de devolução e parâmetros da empresa',
			'[USUÁRIOS/GRUPOS] Keymap: syncFromDom em versa/types/keymap.js para multi-select consistente (sem erro map is not a function)',
			'[CATÁLOGO] Receipt Types: rota #receipt-types registrada em js/main.js',
			'[SAÍDAS] Regra de geração: bloqueia nova saída quando já existe saída em andamento vinculada ao pedido',
			'[RELATÓRIOS] Picking list: exibe quantidade de embalagens a separar por item'
		],
		add: [
			'[MIGRAÇÃO] 045 - aliases de proxy /companies/receipt-types e /companies/packagings com permissões'
		],
		bugfix: [
			'[EMPENHO] Regex do campo Nº empenho corrigida para aceitar/exibir 2025NE02173',
			'[API/PROXY] Endpoints de alias para receipt-types e packagings em ambientes com proxy restrito',
			'[MIGRAÇÃO] 039 input_orders_party_chk criada como NOT VALID para não travar deploy por legado'
		]
	},
	{
		date: '27/03/2026',
		changes: [
			'[MIGRAÇÃO] 031 — colunas de parâmetros por empresa: inventário (inv_allow_expired, inv_require_lot, inv_by_program, inv_class_blocking, inv_conference_tolerance) e embalagens/picking (pkg_use_hierarchy, pkg_unitarization_enabled, pkg_optimize_picking, pkg_allow_tertiary_break, pkg_allow_secondary_break, pkg_validate_gtin, pkg_rollback_legacy); tabela product_packagings + índices únicos (produto+código ativo, GTIN ativo)',
			'[MIGRAÇÃO] 032 — endpoints REST de embalagens (/packagings, CRUD por empresa/produto) e permissões no grupo Administradores',
			'[EMPRESAS] Entidade Company — leitura/gravação dos parâmetros operacionais (inventário + embalagens) alinhados à migração 031',
			'[EMPRESAS] Service update/patch — PUT sem objeto address não apaga endereço já salvo (_COMPANY_ADDRESS_OMIT); front espelha omit de endereço ao salvar',
			'[EMPRESAS] Formulário — fieldset Parâmetros Operacionais com toggles e tolerância; botão ? com textos de ajuda (inventário, hierarquia, picking, GTIN, rollback legado)',
			'[PRODUTOS] Entidade Product — mensagens e documentação em código: campos master_* tratados como medidas da embalagem terciária (rótulos ES/ET na UI; schema/API mantém master_*)',
			'[PRODUTOS] Formulário em abas com ajuda (?) por aba; painel Armazenagem com tabela embutida de embalagens do produto (fetch por produto, Atualizar lista); estilos pill/tabela rolável',
			'[PRODUTOS] UX — Salvar com destaque verde; Inativar/desabilitar com estilo de ação destrutiva (vermelho) onde aplicável',
			'[EMBALAGENS] Domínio completo: entity ProductPackaging (níveis P/S/T, fator, GTIN, qr_code, tertiary_capacity, padrão/inativo); repo com trigger set_serial_id, _ensure_id_sequence + setval para empresas antigas sem sequência',
			'[EMBALAGENS] API routes product_packagings.py — list global, por produto, CRUD; serviço insert/update/patch/delete + insert_or_update para importação e upsert por código',
			'[EMBALAGENS] Front — crud product-packagings, menu Catálogo > Embalagens de produto; IndexedDB store product_packagings; endpoint-function-groups inclui /packagings em Catálogo',
			'[EMBALAGENS] Form product-packagings — campos empresa/produto/código/nível/fator/cap. terciária/GTIN/QR; hints de QR; checkboxes Padrão/Inativa',
			'[EMBALAGENS] Central de importação — chave packagings; colunas Empresa_ID, Produto_ID, Código, Nível, Fator, GTIN, QR Code, Capacidade terciária, Padrão, Inativo; validação GTIN único e existência de produto',
			'[SAÍDAS] Outputs service — injeção de product_packagings: plano de embalagem (_build_packaging_plan), regras de quebra/unitarização por parâmetros da empresa; estatísticas de pedido com coluna Embalagem sugerida (output-orders-output-stats)',
			'[TRANSPORTADORES] update/insert_or_update — omissão de address no PUT não zera endereço (_CARRIER_ADDRESS_OMIT), espelhando empresas',
			'[IMPORTAÇÃO] Central — ajuda (?) por passo, notify em vez de alert, botões primários (Validar/Importar/Nova importação) e Voltar neutro; CSV com separador ;',
			'[INTEGRAÇÕES] TechHub-IBL — módulo dedicado (webhook, pull invoices, process, status flush, push produtos/fatura-itens, health, mappings); tabelas inbox/outbox/local_origins; migração 030 + eventos em integration_events; feature flags TECHHUB_IBL_* (#MT-E29D475, doc ENTREGA-MT-E29D475-TECHHUB-IBL.md)',
			'[INTEGRAÇÕES] Hook after_request — mirror_authenticated_integration_request: tráfego de clientes tipo integração (ex. python-requests) gravado em integration_events (desabilitar SIAL_MIRROR_INTEGRATION_EVENTS=0)',
			'[API/CONFIG] getSialApiHost em api.js para consumidores que precisam da base sem duplicar lógica de HOST',
			'[DEPLOY] PRD-VPN — deploy-evento-prd-vpn-segunda.ps1 e run-deploy-evento-prd-vpn-segunda.ps1 (pacote correções → deploy-full; AWS/SESSP em fluxo separado)'
		]
	},
	{
		date: '24/03/2026',
		changes: [
			'[INTEGRAÇÕES] Central — tabela integration_events, GET/POST /integration-events, listagem leve sem JSONB pesado; seed + migração 029; api list/select/insert (#MT-6531173)'
		]
	},
	{
		date: '23/03/2026',
		changes: [
			'[TRANSPORTADORES] Cadastro – armazena NULL em cpf/cnpj quando o campo não se aplica (PJ→cpf NULL, PF→cnpj NULL), evitando violação da constraint carriers_cpf ao cadastrar múltiplos transportadores PJ',
			'[NF-E] Transportador – CNPJ/CPF enviados sem formatação (apenas dígitos) para conformidade com o XSD da SEFAZ ([0-9]{14}/[0-9]{11})',
			'[PEDIDOS SAÍDA] Relatório de Pendências – refatoração da query: agregar itens do pedido antes do JOIN com fornecido para evitar duplicação; Qtde Forn exclusivamente de output_items (Saída) e Qtde Solic de output_order_items (Espelho), alinhando relatórios',
			'[PEDIDOS SAÍDA] Relatório de Pendências – correção do fornecido quando pedido usa partial_sku e saída registra produto filho/variante (match por SKU além de product_id)',
			'[PEDIDOS SAÍDA] Relatório de Pendências – correção array_length(partial_sku): garantir tipo text[] na CTE e verificação NULL antes de chamar array_length',
			'[PEDIDOS SAÍDA] Relatório de Pendências – considera apenas saídas conferidas (status >= Conferido) para Qtde Forn; alinha com AR (Solicitado − Enviado = Pendências)',
			'[UI] Indicador de carregamento – spinner circular azul + texto "Carregando..." (substitui favicon girando nas requisições)',
			'[SAÍDAS] Aviso de Remessa – incluir número do pedido SIAL na seção Transportadora (#MT-8BEF169)'
		]
	},
	{
		date: '20/02/2025',
		changes: [
			'[PEDIDOS SAÍDA] Status 30 exibido como "Parcialmente atendido" (UI e relatórios); documentação BI em doc/Analises/BI-PEDIDOS-SAIDA-PARCIAIS.md (status=30 + endpoint /pending para itens não atendidos)',
			'[PEDIDOS SAÍDA] Espelho de Pedido – logo SIAL (logo_h1.png) no cabeçalho do PDF quando a empresa não possui logo cadastrado',
			'[NF-E] Local de Entrega – bloco "Informações do local de Entrega" exibido apenas quando o endereço de entrega for diferente do endereço de faturamento (#MT-2932728)',
			'[TRANSPORTADORES] Cadastro – submit próprio (submitHandler) sem depender de formset global; normalização Tipo (PJ→J, PF→F) e Tipo IE (Contribuinte→1, Isento→2, Não Contribuinte→9) para a API; rota aceita company_id por nick (LLT) com resolução para UUID; seed_db.py --endpoints-only para atualizar permissões do grupo Administradores'
		],
		add: [
			'[SEED] Opção --endpoints-only em seed_db.py para inserir endpoints faltantes e atribuir ao grupo Administradores (corrige 403 em Transportadores e outros)'
		],
		bugfix: [
			'[NF-E] Evita duplicar destinatário e local de entrega na nota quando endereços são iguais (#MT-2932728)',
			'[TRANSPORTADORES] 400 tipo/ie_type – envio de códigos (J, 1/2/9) em vez de labels (PJ, Contribuinte); auth aceita company nick na URL'
		]
	},
	{
		date: '18/03/2026',
		changes: [
			'[PROTHEUS] Integração SIAL → Protheus – envio de order_ids em lotes de 100 para API SIAL (evita Invalid request e restaura envio ao WS-DG3)'
		],
		add: [
			'[INFRA] Deploy Protheus – script deploy-protheus-vpn.ps1 (SCP + build no servidor ou build local + ECR push, restart container em 10.10.0.203)'
		],
		bugfix: [
			'[PROTHEUS] Dockerfile – chmod +x em src/entrypoint para container iniciar corretamente (permission denied)'
		]
	},
	{
		date: '13/03/2026',
		changes: [
			'[SAÍDAS] Conferência – relatório com layout igual ao picking (Dados Operação, Depositante, Destinatário, tabela itens Qt Req/Forn/OK/Falta/Sobra, rodapé conferente) (#MT-271C982)',
			'[ENTRADAS] Conferência – relatório reformulado com mesmo layout da conferência de saída (#MT-271C982)',
			'[SAÍDAS] Derrubada de Pallets – numeração por pedido (pedido X - Página N de M), rodapé Sistema SIAL (#MT-271C982)',
			'[DANFE] Layout Protheus – coluna por campo, descrição completa sem corte, Lote/Validade em linhas separadas, quebra de página em dados adicionais (#MT-765B153)',
			'[SAÍDAS] Etiquetas de expedição – apenas saídas com status Conferida podem gerar etiquetas (#MT-7003556)',
			'[GRID] Checkbox não persistente – desmarca ao recarregar página ou ao executar ação; evita itens marcados sem visualização (#MT-E231871)',
			'[PICKING/FEFO] Itens vencidos excluídos do motor – nunca participam da separação; lotes a 30 dias do vencimento bloqueados automaticamente via batch (#MT-38B8742)'
		],
		add: [
			'[BATCH] block_expiring_lots – bloqueia lotes vencidos ou a 30 dias do vencimento; rodar diariamente via cron'
		],
		bugfix: [
			'[CONFERÊNCIA ENTRADA] unhashable type list – sku (TEXT[]) convertido para string antes de uso como chave (#MT-271C982)',
			'[CONFERÊNCIA SAÍDA] 403 – endpoint /outputs/print-conference adicionado à migração 014',
			'[DERRUBADA PALLETS] location nulo – tratamento defensivo; endpoint na migração 014'
		]
	},
	{
		date: '12/03/2026',
		changes: [
			'[IMPORTAÇÃO] Planilha de clientes – colunas adicionais (endereço, Prazo_Entrega, Condicao_Pagto_ID, Lista_Precos_ID, Consumidor); suporte tipo L com código GSNet; linhas de instrução no template (#MT-F037963)',
			'[CLIENTES] Relatório de Cadastro – menu Imprimir, filtros (Empresa, Estado, Tipo, Tipo IE, Consumidor), layout tipo AR com logo SIAL (#MT-A082998)',
			'[CLIENTES] Adequação CNPJ para GSNet – tipo Local aceita código GSNet; Condição de Pagamento opcional e readonly; payment_term_id nulo ao salvar; mesclagem de endereços billing/delivery (#MT-59A4923)',
			'[CADASTROS] Consulta CEP – ao sair do campo CEP (blur), busca ViaCEP e preenche logradouro, bairro, UF e município (Clientes, Empresas, Fornecedores, Transportadores)',
			'[CADASTROS] Campo Município – índice explícito para carga de cidades por UF (persistência correta)'
		],
		add: [],
		bugfix: []
	},
	{
		date: '11/03/2026',
		changes: [
			'[PEDIDOS SAÍDA] Upload de planilha – pedido criado com todos os itens (incl. sem estoque); relatório mantém sem_estoque e pendentes apenas para informação (#MT-25FE283)'
		],
		add: [],
		bugfix: [
			'[CATÁLOGO] PRODUTOS – filtro passa a injetar parâmetro na API (await em addFilter; preventDefault no form de filtro)'
		]
	},
	{
		date: '10/03/2026',
		changes: [
			'[SAÍDAS] Modal Resultados – completo com Cliente, Pedido, Transportador, Programa, % atendimento, posições e tabela de itens (SKU, Nome, Lote, Unidade, Solicitado, Atendido, %, Posição)',
			'[SISTEMA] CENTRAL DE IMPORTAÇÃO – importação completa: Clientes, Fornecedores, Transportadores, Fabricantes, Programas, Produtos, Posições (CSV/XLSX, validação, importação)',
			'[FATURAMENTO] Relatório IQVIA – campo data em texto (dd/mm/aaaa), período data início e data fim (opcional)',
			'[AUTH] Mensagem 403 – indica endpoint faltante (método + path) e termo de busca para Sistema > Grupos (search_hint em português)',
			'[SISTEMA] GRUPOS – ícones de inclusão/exclusão de endpoints e empresas substituídos por "← Incluir" e "Remover →"',
			'[PEDIDOS SAÍDA/ENTRADA] Upload de planilha – colunas SKU, Quantidade, Preço/Vlr; CSV ou XLSX; relatório com SKU não encontrado (vlr vazio), sem estoque e pendentes (#MT-25FE283)',
			'[PEDIDOS SAÍDA] Valor total do pedido passa a considerar desconto por item (preço × (1 - % desc))',
			'[PEDIDOS SAÍDA] Coluna % Desconto na listagem: média ponderada dos itens quando header vazio; exibe 0,00 quando zero',
			'[TABELA PREÇOS] Tabela por cliente: campo desconto geral no header vazio ao abrir (evita sobrescrever desconto por item ao salvar)',
			'[PEDIDOS SAÍDA] Formulário: não preenche preço em linhas sem produto; desconto por item persistido ao salvar'
		],
		add: [],
		bugfix: [
			'[PICKING] partial_sku vazio – pedidos com 90% estoque apareciam 0,3% atendimento; correção SQL (LIKE só quando partial_sku preenchido)',
			'[ESTOQUE] Tratamento de lotes em notação científica (E/D) em versa/misc.js e order_upload',
			'[PEDIDOS SAÍDA] obs_price: preço 9.999 em linhas vazias – usar value como product_id só quando mudança veio do campo produto',
			'[PEDIDOS SAÍDA] Salvamento: ignorar itens sem product_id; envio correto de desconto (null quando vazio)',
			'[API] OutputOrder.set_items: cálculo de value e discount em Decimal (evita erro Decimal * float na listagem)'
		]
	},
	{
		date: '09/03/2026',
		changes: [
			'[CATÁLOGO] PRODUTOS – formulário em abas (Dados, Armazenagem, Tributação); campos Portaria 344 na aba Armazenagem',
			'[CATÁLOGO] PRODUTOS – modal tamanho fixo; abas com estilo pill; Portaria 344, Embalagens e Classificações em Armazenagem',
			'[API] Produtos: is_portaria_344, portaria_344_list | Pedidos de saída: book_observation (#MT-6C6F740)',
			'[FILTRO] Empresas - usar UUID como value no dropdown (em vez de nick); deduplicar opções',
			'[FILTRO] resolveFilterLabelsToIds - resolver labels para IDs antes das queries (company, warehouse, program, position)',
			'[LAYOUT] Ícone de loading - tamanho 25×25px'
		],
		add: [],
		bugfix: [
			'[ESTOQUE] FILTRO EMPRESA - enviar UUID em vez de nome para API (corrige filtro "Maternidade - Amil 2")'
		]
	},
	{
		date: '09/03/2026',
		changes: [
			'[ESTOQUES] Tela não carrega mais automaticamente - usuário deve clicar em Filtrar e Aplicar (ou aplicar filtros) para carregar dados',
			'[ESTOQUES] Relatórios (SKU, Lote, Posição) - modal para definir filtros e formato (PDF/CSV) antes de gerar',
			'[ESTOQUES] Relatórios - exportação em PDF e CSV'
		],
		add: [],
		bugfix: []
	},
	{
		date: '08/03/2026',
		changes: [
			'[ESTOQUE] FILTRO POSIÇÃO - filtrar por Empresa e Armazém, ordenar por endereço, recarregar locations ao alterar escopo (MT-596E375)',
			'[ESTOQUE] FILTRO POSIÇÃO - resolver label para warehouse_id:location_id; warehouse/company por nome (resolveFilterLabelsToIds)',
			'[LAYOUT] Grid - cor de hover nas células da tabela alterada para #e9dbfd'
		],
		add: [],
		bugfix: [
			'[ESTOQUE] FILTRO POSIÇÃO - posições desordenadas e troca de valor ao selecionar; valor warehouse_id:location_id correto na API'
		]
	},
	{
		date: '06/03/2026',
		changes: [
			'[LAYOUT] Tema claro - fundo branco, variáveis de cor (--color-primary, --color-box, etc.)',
			'[LOGIN] Logo SIAL (logo_sial_grey.png) na tela de autenticação',
			'[SOBRE] Logo MachadoTec ao lado do SIAL; texto "MachadoTec Software Solutions"',
			'[LOGOS] Atualizados logo_h1, logo_h2, logo_v, logo_sial, logo_machadotec (fundo branco)',
			'[RECUPERAÇÃO SENHA] Fluxo completo: POST /auth/requests, GET /auth/reset-form, POST /auth/resets',
			'[DEPLOY] deploy-full e deploy-recuperacao-senha-vpn - templates copiados para /home/sial/config/'
		],
		add: [
			'[AUTH] Recuperação de senha - templates HTML e-mail/formulário, logo no e-mail',
			'[DEPLOY] deploy-recuperacao-senha-vpn.ps1 - script dedicado para deploy da recuperação de senha'
		],
		bugfix: [
			'[AUTH] KeyError reset_base_url - validação e mensagem clara quando config [auth] incompleto',
			'[AUTH] Template não encontrado - fallback para /config/ (mesmo dir do config.ini)'
		]
	},
	{
		date: '03/03/2026',
		changes: [
			'[SAÍDAS] PICK LIST - novo layout (REFERÊNCIA, 3 blocos, QR, SKU destacado, cod. cliente, lote fab) - Chamado #MT-C120592',
			'[SAÍDAS] AVISO REMESSA - campo Observações do pedido incluído no documento - Chamado #MT-234E920'
		],
		add: [
			'[TRANSPORTADORES] Modo local de entrega - flag para cadastro simplificado (CPF/CNPJ/IE opcionais, tipo LOCAL) - Chamado #MT-72C8316',
			'[FATURAMENTO] NOTAS FISCAIS - Operações > Inutilizar NF (série, faixa, justificativa) - Chamado #MT-FE53820',
			'[FATURAMENTO] NOTAS FISCAIS - coluna Inutilizada exibe protocolo SEFAZ',
			'[FATURAMENTO] NOTAS FISCAIS - evento de Inutilização na tabela de protocolos do detalhe',
			'[NFE] NF-E ATIVO IMOBILIZADO - página /nfe-ativo-imobilizado (Chamado #MT-5EA7507)'
		],
		bugfix: [
			'[FORMS] Carriers - correção querySelector no init do formulário',
			'[NFE] Faturamento - transporta sem CPF/CNPJ quando transportador em modo local de entrega'
		]
	},
	{
		date: '02/03/2026',
		changes: [
			'[SAÍDAS] ETIQUETAS EXPEDIÇÃO - QR code ^FO600,420^BQN,4,4',
			'[SAÍDAS] PICKLIST - contador página individual por pedido (1/2, 2/2)',
			'[ESTOQUE] VIEW - colunas Nota Entrada e Fornecedor',
			'[SAÍDAS] VIEW - coluna Referência e filtro',
			'[SAÍDAS] AVISO REMESSA - layout reformulado, itens em ordem alfabética',
			'[NFE] CFOPS - operações de fiel depositário (5905, 5906, 5907, etc.)'
		],
		add: [
			'[MIGRAÇÃO] 016 - desabilitar armazéns RVD-AMIL-1 e RVD-AMIL-2',
			'[ENTRADAS] ETIQUETAS - separador "FIM DE LOTE" entre lotes',
			'[ENTRADAS] RELATÓRIO - Entrada Detalhada (NF, Data Entrada, SKU, Lote, Fab, Val)'
		],
		bugfix: [
			'[API] INPUTS.inventory - program_id opcional (ColetorPWA conferência entrada)',
			'[API] OUTPUTS.update/patch - aceitar program_id e reference (ColetorPWA)',
			'[API] INPUTS.putaway - aceitar program_id (endereçamento ColetorPWA/SIAL)',
			'[API] OUTPUTS print-picklists - função duplicada corrigida',
			'[API] OUTPUTS separação - status não vai mais para CONFERIDO ao finalizar'
		]
	},
	{
		date: '25/02/2026',
		changes: [
			'[AVISO REMESSA] LAYOUT - assinatura na mesma página que a tabela'
		],
		add: [],
		bugfix: [
			'[API] OUTPUTS - query com subselect para program_id (corrige ColetorPWA)',
			'[RELATÓRIO CONFERÊNCIA] SQL - verified_user.nick → verified_user.name'
		]
	},
	{
		date: '19/02/2026',
		changes: [
			'[SAÍDAS] PROGRAMA - coluna, filtro e detalhe',
			'[PEDIDOS SAÍDA] PROGRAMA - coluna e filtro',
			'[PEDIDOS ENTRADA] PROGRAMA - coluna, filtro e campo',
			'[ENTRADAS] PROGRAMA - coluna, filtro e detalhe',
			'[ESTOQUE] VIEW - detalhes e novas colunas (SKU, NCM, EAN, Programa)',
			'[ESTOQUE] MOD - somente consulta, sem Inserir',
			'[MOVIMENTAÇÃO] MOVE - Lote e posição origem readonly'
		],
		add: [
			'[MIGRAÇÃO] 013 - saneamento program_id com programa padrão',
			'[PEDIDOS] OUTPUT/INPUT - default programa no insert',
			'[CONFERÊNCIA] RELATÓRIO - relatório de conferência (esperado x conferido)',
			'[SOBRE] CHANGELOG - histórico dos últimos 10 dias'
		],
		bugfix: [
			'[COMPANIES] LIST_ALL - aceitar parâmetro include_disabled',
			'[SAÍDAS] ETIQUETAS - correção na impressão de etiquetas de expedição (volumes)',
			'[ENTRADAS] PRINT-CONFERENCE - permissão de endpoint para relatório de conferência',
			'[SAÍDAS] PRINT-AVISO-REMESSA - permissão de endpoint para aviso de remessa'
		]
	}
	// Manter no máximo 10 dias. Adicionar novas entradas no topo.
];


